import { API_ORIGIN, apiUrl } from "./apiOrigin";
import React, { useEffect, useState } from 'react';
export default function PharmacyOpeningHours({
  dbName,
  token
}) {
  const [data, setData] = useState(null),
    [error, setError] = useState('');
  useEffect(() => {
    let off = false;
    setData(null);
    setError('');
    if (!dbName) {
      setError('Branch database could not be resolved.');
      return;
    }
    fetch(`${API_ORIGIN}/api/headoffice/compliance-grid/pharmacy-opening-hours?dbName=${encodeURIComponent(dbName)}`, {
      headers: {
        Authorization: `Bearer ${token || localStorage.getItem('token') || ''}`
      }
    }).then(async r => {
      const d = await r.json();
      if (!r.ok) throw Error(d.error || 'Unable to load opening hours');
      return d;
    }).then(d => {
      if (!off) setData(d[0] || null);
    }).catch(e => {
      if (!off) setError(e.message);
    });
    return () => {
      off = true;
    };
  }, [dbName, token]);
  const hours = n => `${Math.floor(n / 60)}h ${n % 60 ? `${n % 60}m` : ''}`.trim();
  return <section aria-label="Pharmacy opening hours" style={{
    padding: 12,
    border: '1px solid #94a3b8',
    borderRadius: 6,
    background: '#fff',
    color: '#172554',
    fontSize: 13
  }}><h4>Pharmacy opening hours</h4>{error ? <p role="alert">{error}</p> : !data ? <p>Loading…</p> : <><b>{data.pharmacyName}</b><table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}><thead><tr><th style={{
              textAlign: 'left'
            }}>Day</th><th style={{
              textAlign: 'left'
            }}>Opening sessions</th><th>Daily total</th></tr></thead><tbody>{data.days.map(d => <tr key={d.day}><td style={{
              padding: 5
            }}>{d.name}</td><td>{d.sessions.length ? d.sessions.map(s => `${s.start}–${s.end}`).join(', ') : 'Closed'}</td><td style={{
              textAlign: 'center'
            }}>{hours(d.totalMinutes)}</td></tr>)}</tbody><tfoot><tr><th colSpan={2} style={{
              textAlign: 'left',
              padding: 6
            }}>Total open per week</th><th>{hours(data.weeklyMinutes)} ({Number(data.weeklyHours.toFixed(2))} hours)</th></tr></tfoot></table>{data.problems?.length > 0 && <p role="alert">Check recorded hours: {data.problems.join('; ')}</p>}<p style={{
        fontSize: 12
      }}>{data.note}</p><p style={{
        fontSize: 11
      }}>Source: {data.source}</p></>}</section>;
}
